import { render } from "./AccountMain.vue?vue&type=template&id=3291a6ca"
import script from "./AccountMain.vue?vue&type=script&lang=js"
export * from "./AccountMain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__